import { render, staticRenderFns } from "./sydl.vue?vue&type=template&id=0b5fbfce&scoped=true&"
import script from "./sydl.vue?vue&type=script&lang=js&"
export * from "./sydl.vue?vue&type=script&lang=js&"
import style0 from "./sydl.vue?vue&type=style&index=0&id=0b5fbfce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5fbfce",
  null
  
)

export default component.exports